import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Brand from '../components/Brand';
import { affiliatesAPI } from '../lib/api';
import { t } from '../lib/i18n';
import { panelCls } from '../components/ui';

// Public program pages (/terms, /disclaimer) — referred visitors can read
// them without an account (plan §7 compliance surface).
export default function PolicyPage({ pageKey }) {
  const params = useParams();
  const key = pageKey || params.key;
  const [data, setData] = useState(undefined);

  useEffect(() => {
    affiliatesAPI.publicPage(key).then(({ data }) => setData(data)).catch(() => setData(null));
  }, [key]);

  return (
    <div className="min-h-screen px-4 py-12">
      <div className="mx-auto max-w-2xl">
        <div className="mb-8 text-center">
          <Brand size="lg" className="justify-center" />
          <h1 className="mt-3 text-lg font-semibold">
            {key === 'terms' ? t('Program terms') : t('Disclaimer')}
          </h1>
        </div>
        {data === undefined ? (
          <p className="text-center text-sm text-mms-muted">{t('Loading…')}</p>
        ) : data === null ? (
          <p className="text-center text-sm text-mms-muted">{t('This page is not published yet.')}</p>
        ) : (
          <div className={`${panelCls} whitespace-pre-wrap p-6 text-sm leading-relaxed text-mms-muted`}>
            {data.body}
          </div>
        )}
      </div>
    </div>
  );
}
